import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-500Error',
  templateUrl: './500error.component.html',
  styleUrls: ['./503error.component.css']
})
export class Error500Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}